export default __webpack_public_path__ + "static/media/PremiumIcon.18e12a95.svg";